import { render } from "./MerchantManagement.vue?vue&type=template&id=0f3f673a&scoped=true"
import script from "./MerchantManagement.vue?vue&type=script&lang=js"
export * from "./MerchantManagement.vue?vue&type=script&lang=js"

import "./MerchantManagement.vue?vue&type=style&index=0&id=0f3f673a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3f673a"]])

export default __exports__